import {AnchorExternal, RsnDialog, RsnTextButton} from '@raison/ui-kit';
import classNames from 'classnames';
import React, {ComponentProps, FC} from 'react';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router';
import {legacyModalsApi} from '~/entities/dialogs';
import RsnButton from '~/shared/legacy_presentational-components/Rsn/buttons/Button/RsnButton';
import buttonStyles from '~/shared/legacy_presentational-components/Rsn/buttons/lightblueButtonStyles/lightblueButtonStyles.module.scss';

export interface LoginErrorModalProps {
    closeAction: () => void;
    callBackBtn: () => void;
    userName?: string;
    title?: string;
    context?: string;
    code?: number;
    link?: string;
    type?: ComponentProps<typeof RsnDialog.StatusIcon>['status'];
}

const LoginErrorModal: FC<LoginErrorModalProps> = ({
    link,
    closeAction,
    callBackBtn,
    userName,
    title,
    context,
    code,
    type = 'alert',
}) => {
    const loginErrorModal = useSelector(legacyModalsApi.select('loginSignupPage', 'loginErrorModal'));

    const navigate = useNavigate();

    const chooseContent = () => {
        if (code === 400 && !title?.includes('You need to wait a bit'))
            return title?.includes('Invalid password or phone number') ? (
                <>
                    <RsnDialog.CenteredHeader icon={{element: <RsnDialog.StatusIcon status={type} />}}>
                        {title} {userName}
                    </RsnDialog.CenteredHeader>
                    <RsnDialog.Body>
                        <span>Don&apos;t you have an account yet?</span>
                        <RsnTextButton.Block
                            onClick={() => {
                                navigate('/signup');
                            }}
                        >
                            Go to the registration
                        </RsnTextButton.Block>
                    </RsnDialog.Body>
                </>
            ) : (
                <>
                    <RsnDialog.CenteredHeader icon={{element: <RsnDialog.StatusIcon status={type} />}}>
                        {title}
                    </RsnDialog.CenteredHeader>
                    <RsnDialog.Body>
                        <div>If you have any questions, please get in touch with our support team.</div>
                        <RsnTextButton.Block
                            onClick={() => {
                                navigate('/support/form');
                            }}
                        >
                            Contact support
                        </RsnTextButton.Block>
                    </RsnDialog.Body>
                </>
            );
        else
            return (
                <>
                    <RsnDialog.CenteredHeader icon={{element: <RsnDialog.StatusIcon status={type} />}}>
                        {title}
                    </RsnDialog.CenteredHeader>
                    <RsnDialog.Body>{context}</RsnDialog.Body>
                    <RsnDialog.Footer>
                        {link ? (
                            <AnchorExternal href={link} className={buttonStyles.btn}>
                                Continue
                            </AnchorExternal>
                        ) : (
                            <RsnButton
                                title='I got it'
                                className={classNames(buttonStyles.btn, buttonStyles.lightBlueBckgr)}
                                originalCaseTitle
                                onClickCallback={callBackBtn}
                            />
                        )}
                    </RsnDialog.Footer>
                </>
            );
    };

    return (
        <RsnDialog.Controller isOpen={loginErrorModal} onClose={closeAction}>
            <RsnDialog.Window>{chooseContent()}</RsnDialog.Window>
        </RsnDialog.Controller>
    );
};

export default LoginErrorModal;
